<template>
  <t-block-allow-domain
    v-if="selectedUser.id"
    :id="selectedUser.id"
    :tier="TIER.users"
  ></t-block-allow-domain>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import TBlockAllowDomain from "@/views/Common/TBlockAllowDomain";

import { TIER } from "@/constants/tier";

export default {
  name: "Domains",
  components: {
    TBlockAllowDomain,
  },
  data() {
    return {
      TIER,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Allow & Block List"));
    this.setPageSubtitle([]);
  },
};
</script>
